import React from 'react';
import { useIntl } from 'react-intl';

import { SfaFatalError } from '../sfa-fatal-error/sfa-fatal-error';

import image from './no-results-found.svg';

export const SfaSetupNotCompleteFatalError = () => {
  const intl = useIntl();

  const text = {
    title: intl.formatMessage({
      id: 'onboarding.sfa.we_could_not_link_to_this_organisation',
      defaultMessage: 'We could not link to this organisation'
    }),
    subtitle: intl.formatMessage({
      id: 'onboarding.sfa.the_organisation_setup_is_not_complete',
      defaultMessage: 'The organisation setup is not complete.'
    }),
    text: intl.formatMessage({
      id: 'onboarding.sfa.return_to_futrli_and_finish_setting_up_link_org',
      defaultMessage: 'Return to Futrli and finish setting up the organisation you want to link to, then try again.'
    })
  };

  return <SfaFatalError image={image} {...text} />;
};
